var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-text',{staticClass:"rounded overflow-hidden"},[_c('div',{attrs:{"id":"chartdiv"}})])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }